// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8c01a3c4","952":"87e9f494"}[chunkId] + ".chunk.js";
};